import { z } from 'zod';

/**
 * Campos Zod reutilizáveis em múltiplos schemas. Mensagens são **chaves i18n**
 * (namespace `validation`) — traduzidas no consumo via `useFieldError` no front
 * ou `t()` no back (Edge Functions).
 *
 * Regra §5.3 do CLAUDE.md: nunca colocar pt-BR cru aqui.
 */

/** Email normalizado (trim + lowercase) com validação formato + obrigatório.
 * Trim/lowercase acontecem **antes** do check, para aceitar copy-paste com
 * espaços sem que o formato falhe. */
export const emailField = z
  .string()
  .trim()
  .toLowerCase()
  .min(1, 'validation:email.required')
  .email('validation:email.invalid');

/** Senha com regra KmGestao: 12–128 chars. Validação de força deve ser composta
 * via `.regex(passwordStrengthPattern, 'validation:password.strength')`
 * onde faz sentido (signup, reset confirm) — para login basta `.min(1)`. */
export const passwordField = z
  .string()
  .min(12, 'validation:password.tooShort')
  .max(128, 'validation:password.tooLong');

/** Regex de força: exige minúscula, maiúscula, dígito e símbolo. */
export const passwordStrengthPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/;

/** Token do captcha (hCaptcha). Em produção é obrigatório; em dev pode ser bypass. */
export const captchaTokenField = z.string().min(1, 'validation:captcha.required');
